export const classGroup = [
  {
    value: 'class',
    label: 'Classes',
  },
  {
    value: 'custom',
    label: 'Student Groups',
  },
]

export const ruleLimit = 10

export const debounceWait = 500

export const inNotInOp = [
  { name: 'in', label: 'Is In' },
  { name: 'notIn', label: 'Is Not In' },
]

export const equalNotEqualOp = [
  { name: '=', label: '=' },
  { name: '!=', label: '!=' },
]

export const nullNotNullOp = [
  { name: 'null', label: 'Is Null' },
  { name: 'notNull', label: 'Is Not Null' },
]

export const combinators = [
  { name: 'and', label: 'All criteria' },
  // { name: 'or', label: 'Any criteria' }, // commenting it not removing it
]
